/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect,useState, useRef, Key, ReactChild, ReactFragment, ReactPortal } from 'react'

import { getCSSVariableValue } from '../../../../assets/ts/_utils'
import { useThemeMode } from '../../../layout/theme-mode/ThemeModeProvider'
import moment from 'moment'
type Props = {
  className: string
  chartSize?: number
  chartLine?: number
  chartRotate?: number
}

const ListsWidget26: FC<Props> = ({
  className,
  chartSize = 70,
  chartLine = 11,
  chartRotate = 145,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const [selectedOption, setSelectedOption] = useState<string>('Select the devision'); 
  
  const [selectedOptionZone, setSelectedOptionZone] = useState<string>('1');// Initialize with 'Total' or any default option
  let [selectedData, setSelectedData] = useState<any>([]);
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    
    const selectedValue = event.target.value;
    console.log(selectedValue,"selectedOption");
    OrderCoverd(selectedValue)
   
    
  };




  const OrderCoverd = (selectedValue: string)=>{
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
  
    const raw = JSON.stringify({
      "division":selectedValue,
  
    });

    console.log(raw,"raw");
    
  
    const requestOptions: RequestInit = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
  
    fetch("https://crm.romsons.com:8080/ZonewiseWeb", requestOptions)
      .then(response => response.text())
      .then(result => {
        let arr = JSON.parse(result)
        selectedData = arr.data;
        setSelectedData(selectedData);
        console.log(selectedData,"result");
      })
      .catch(error => console.log('error', error));
  }

  const currentDate = moment();
  const currentMonth = currentDate.format('MMMM-YYYY');

  return (
    <div className={`card card-flush ${className}`}>
      <div className='card-header pt-5'>
        <div className='card-title d-flex flex-column'>
          <div className='d-flex align-items-center'>
           

            <span className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>Order Coverage</span>

          
          </div>
          <span className='text-gray-400 pt-1 fw-semibold fs-6'>Division & Zone wise Information</span>
          <span className='text-dark pt-1 fw-semibold fs-6'>  {currentMonth}</span>        
        </div>
      </div>
      <label>Select devision</label>
      <select value={selectedOption} onChange={handleSelectChange}>
      <option value='Select the devision'>Select the devision</option>
              <option value='1'>Retail</option>
              <option value='2'>MSD</option>
              <option value='3'>KAD</option>
              <option value='6'>OPS</option>
              <option value='7'>GOVT</option>
              <option value='5'>GTD</option>
              {/* Add more options as needed */}
            </select>
<br/>


      <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
      

   

      <table>
  <thead>
    <tr>
      <th>Zone Name</th>
      <th>Order Value</th>
    </tr>
  </thead>
  <tbody>
    {selectedData.map((res: { zone_name: boolean | ReactChild | ReactFragment | ReactPortal | null | undefined; ordervalue: boolean | ReactChild | ReactFragment | ReactPortal | null | undefined }, ind: Key | null | undefined) => (
      <tr key={ind}>
        <td>{res.zone_name}</td>
        <td>{Number(res.ordervalue).toFixed(3)}</td>
      </tr>
    ))}
  </tbody>
</table>

      </div>
    </div>
  )
}



export { ListsWidget26 }
